import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Alert,
    CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { apiSlice } from 'store/slices/apiSlice';

export default function ProjectMembersDialog({ projectName, onClose }) {
    const [emailToAdd, setEmailToAdd] = useState('');
    const [addError, setAddError] = useState(null);
    const { data: members = [], isLoading, error } = apiSlice.useGetProjectMembersQuery(projectName, { skip: !projectName });
    const [addMember, { isLoading: adding }] = apiSlice.useAddProjectMemberMutation();
    const [removeMember, { isLoading: removing }] = apiSlice.useRemoveProjectMemberMutation();

    const handleAdd = async () => {
        const email = (emailToAdd || '').trim();
        if (!email) return;
        setAddError(null);
        try {
            await addMember({ projectName, email }).unwrap();
            setEmailToAdd('');
        } catch (err) {
            setAddError(err?.data?.detail || err?.message || 'Thêm thất bại');
        }
    };

    const handleRemove = async (userId) => {
        try {
            await removeMember({ projectName, userId }).unwrap();
        } catch (err) {
            // could set error state
        }
    };

    return (
        <Dialog open={!!projectName} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Thành viên project: {projectName}</DialogTitle>
            <DialogContent>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error?.data?.detail || 'Không tải được danh sách'}
                    </Alert>
                )}
                {addError && (
                    <Alert severity="error" sx={{ mb: 2 }} onClose={() => setAddError(null)}>
                        {addError}
                    </Alert>
                )}
                <TextField
                    fullWidth
                    size="small"
                    label="Thêm thành viên (email)"
                    value={emailToAdd}
                    onChange={(e) => setEmailToAdd(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleAdd())}
                    sx={{ mb: 2 }}
                />
                <Button
                    startIcon={adding ? <CircularProgress size={16} /> : <PersonAddIcon />}
                    variant="outlined"
                    onClick={handleAdd}
                    disabled={!emailToAdd.trim() || adding}
                    size="small"
                    sx={{ mb: 2 }}
                >
                    Thêm
                </Button>
                {isLoading ? (
                    <CircularProgress size={24} />
                ) : (
                    <List dense>
                        {members.map((m) => (
                            <ListItem key={m.id}>
                                <ListItemText primary={m.email || m.user_id} secondary={m.full_name || null} />
                                <ListItemSecondaryAction>
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => handleRemove(m.user_id)}
                                        disabled={removing}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                        {members.length === 0 && !isLoading && (
                            <ListItem>
                                <ListItemText primary="Chưa có thành viên nào (ngoài owner/admin)." />
                            </ListItem>
                        )}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Đóng</Button>
            </DialogActions>
        </Dialog>
    );
}
